export default "__VITE_ASSET__CVcB67P6__"